import { FormGroup, FormControl } from '@angular/forms';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup, IResetPasswordConfirmation } from '@shared-libs/interfaces';

export class ResetConfirmFormFactory {
	public static create(): IFormGroup<IResetPasswordConfirmation> {
		return new FormGroup({
			password: new FormGroup(
				{
					new: new FormControl('', [SharedFormValidators.required, SharedFormValidators.password]),
					confirmation: new FormControl('', [SharedFormValidators.required, SharedFormValidators.password]),
				},
				{ validators: SharedFormValidators.passwordConfirmation }
			),
		}) as IFormGroup;
	}
}
